/* eslint-disable */
// Controla as "abas" de relatórios abertos (estilo navegador) e o
// histórico de relatórios acessados recentemente, exibido na tela inicial.

function carregarRecentes() {
    try {
        return JSON
            .parse(localStorage.getItem('relatoriosRecentes') || '[]')
            .slice(0, 4)
    } catch (error) {
        return []
    }
}
export default {
    namespaced: true,

    state: {
        tabs: [],
        abaAtiva: 'inicio',
        recentes: carregarRecentes(),
        reloadTokens: {}
    },

    getters: {
        tabs: (state) => state.tabs,
        abaAtiva: (state) => state.abaAtiva,
        recentes: (state) => state.recentes,
        reloadToken: (state) => (lk_link) => state.reloadTokens[lk_link] || 0
    },

    mutations: {
        ABRIR_ABA(state, link) {
            const existente = state.tabs.find(t => t.lk_link === link.lk_link)

            if (!existente) {
                state.tabs.push({ ...link })
            }

            state.abaAtiva = link.lk_link
        },
        FECHAR_ABA(state, lk_link) {
            const indice = state.tabs.findIndex(t => t.lk_link === lk_link)
            if (indice === -1) return

            state.tabs.splice(indice, 1)

            if (state.abaAtiva === lk_link) {
                const proxima = state.tabs[indice - 1] || state.tabs[indice] || null
                state.abaAtiva = proxima ? proxima.lk_link : 'inicio'
            }

            const { [lk_link]: removido, ...restante } = state.reloadTokens
            state.reloadTokens = restante
        },
        ATIVAR_ABA(state, id) {
            state.abaAtiva = id
        },
        REORDENAR_ABAS(state, novasTabs) {
            state.tabs = novasTabs
        },
        INCREMENTAR_RELOAD(state, lk_link) {
            state.reloadTokens = {
                ...state.reloadTokens,
                [lk_link]: (state.reloadTokens[lk_link] || 0) + 1
            }
        },
        ADICIONAR_RECENTE(state, link) {
            const semDuplicado = state.recentes.filter(r => r.lk_link !== link.lk_link)
            const novaLista = [link, ...semDuplicado].slice(0, 6)

            state.recentes = novaLista
            localStorage.setItem('relatoriosRecentes', JSON.stringify(novaLista))
        }
    },

    actions: {
        async abrirRelatorio({ commit, dispatch, rootGetters }, link) {
            commit('ABRIR_ABA', link)
            commit('ADICIONAR_RECENTE', { ...link, acessadoEm: Date.now() })

            localStorage.setItem('menuSelecionado', JSON.stringify(link.ds_link))

            const data = {
                nr_seq_menu: link.nr_sequencial,
                ds_menu: link.ds_link
            }

            try {
                await dispatch('busca/salvarLog', { data }, { root: true })

                const empresa = JSON.parse(localStorage.filial)
                const empresaColaboradorApi = rootGetters['busca/getEmpresaColaborador']

                if (empresa.empresa != empresaColaboradorApi || empresa.empresa == 'VITORIALOG') {
                    dispatch('busca/logout', null, { root: true })
                }
            } catch (error) {
                dispatch('busca/logout', null, { root: true })
            }
        },
        fecharAba({ commit }, lk_link) {
            commit('FECHAR_ABA', lk_link)
        },
        ativarAba({ commit }, id) {
            commit('ATIVAR_ABA', id)
        },
        reordenarAbas({ commit }, novasTabs) {
            commit('REORDENAR_ABAS', novasTabs)
        },
        recarregarAba({ commit }, lk_link) {
            commit('INCREMENTAR_RELOAD', lk_link)
        }
    }
}
